import split from 'lodash/split';
import indexOf from 'lodash/indexOf';

const filterMachinery = ({
  name, value, oldFilters, filtersFormRef,
}) => {
  const newFilters = { ...oldFilters };
  if (name === 'sort' || name === 'format' || name === 'state') {
    newFilters[name] = [value];

    if (name === 'format' || name === 'state') {
      newFilters.brands?.forEach((brand) => filtersFormRef?.setFieldValue(`brands_${brand}`, false));
      delete newFilters.brands;
      newFilters.locations?.forEach((location) => filtersFormRef?.setFieldValue(`locations_${location}`, false));
      delete newFilters.locations;
    }
  } else {
    const item = split(name, '_');

    if (newFilters[item[0]]) {
      if (value !== false) {
        newFilters[item[0]].push(item[1]);
      } else {
        const filterIndex = indexOf(newFilters[item[0]], item[1]);
        if (filterIndex !== -1) {
          newFilters[item[0]].splice(filterIndex, 1);
        }
      }
    } else if (value === true) {
      newFilters[item[0]] = [item[1]];
    }
  }

  return newFilters;
};

export default filterMachinery;
